/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { Card, Col, Container, Row, Form, Button } from 'react-bootstrap';
import CookiesService from '../../shared/CookiesService';
import APIEndpoints from '../../api/APIEndpoints';
import RetryAPI from '../../api/RetryAPI';
import HttpErrorHandler from '../../errorhandling/HttpErrorHandler';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../errorhandling/HttpErrorCodes';
import Header from './header';
import Footer from './footer';
import Authenticated from '../../shared/Authenticated';
import { axiosInstance } from '../../../api/axios';
import GenericButton from '../../../Components/GenericButton/GenericButton';

const LoginOTP = (props) => {
  const [otp, setOTP] = useState();
  const [otpValid, setOTPValid] = useState(false);
  const navigate = useNavigate();
  const [min, OTPexpires] = useState(1);
  const [len, OTPlength] = useState(4);
  const [att, OTPattempts] = useState(1);
  const [lock, locked] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [generateOTP, generateOTPCode] = useState(true);
  const [loadAdminConfig, setLoadAdminConfig] = useState(true);
  const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

  let bearerToken, refreshToken;
  let oneTimePasswordValue = '';
  const oneTimePassword = '';
  const emailID = localStorage.getItem('email-id');

  const maskEmail = (email) => {
    const emailLength = email?.length;
    const pos = email.indexOf('@');
    return (
      email.substring(0, 3) +
      email.substring(3, pos).replace(/[a-z,A-Z]/gi, 'x') +
      email.substring(pos, emailLength)
    );
  };

  const schema = yup.object({
    oneTimePassword: yup
      .string()
      .matches(/^[0-9]*$/, 'Enter your ' + len + '-digit authentication code')
      .min(len, 'Enter your ' + len + '-digit authentication code')
      .max(len, 'Enter your ' + len + '-digit authentication code')
      .required('Enter your ' + len + '-digit authentication code'),
  });

  const verifyOtp = async (otp) => {
    const response = null,
      verifyOTPResponse = null,
      verifyOTPDataResp = null;

    try {
      bearerToken = CookiesService.get('loginToken');
      //const verifyOTPAPI = axios.create({
      //headers: {
      //Authorization: bearerToken,
      //'X-ClientID': HttpHeader.getCNAME(),
      //Accept: 'application/json',
      //},
      //});

      if (otpValid) {
        const response = await axiosInstance.get(
          cacheBuster(
            APIEndpoints.getOtpVerifyResources() + otp + '/userid/' + emailID,
          ),
        );
        //verifyOTPResponse = EncrptedResp;
        //response = verifyOTPResponse;
        //refreshToken = response.config.headers.Authorization;
        //HttpHeader.refreshBearerToken(refreshToken);
        const verifyOTPDataResp = response.data;
        //verifyOTPDataResp = verifyOtpData;

        if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
          if (verifyOTPDataResp === 'OK') {
            Authenticated.login(async () => {
              navigate('/admin/admin-dashboard');
            });
          }
        } else {
          RetryAPI.setResponseReceived(false);
          RetryAPI.setErrorCode(response.status);
          const errorCode = RetryAPI.getErrorCode();
          if (
            HttpErrorHandler.ProcessedException(
              errorCode,
              'Unable to verify your OTP code now.',
            )
          ) {
            setServerError(true);
          }
        }
      }
    } catch (error) {
      RetryAPI.setResponseReceived(false);
      RetryAPI.setErrorCode(error.response.status);
      const errorCode = RetryAPI.getErrorCode();

      if (errorCode === 400) {
        //eslint-disable-next-line no-useless-escape
        const err = error.response.data.message.replace(/[\["\]]/g, '');
        const lockCheck = err.indexOf('Failed count');
        const attemptsMsg = lockCheck > 0 ? ' of ' + att : '';
        if (lockCheck < 0) {
          const logoutRequest = await Promise.all([LogoutRequest()]);
          locked(true);
        }
        document.querySelector('.invalid-feedback p').innerText =
          err + attemptsMsg;
        document.querySelector('.invalid-feedback').style.display = 'block';
      } else {
        if (
          HttpErrorHandler.ProcessedException(
            errorCode,
            'Unable to verify your OTP code now.',
          )
        ) {
          setServerError(true);
        }
      }
    }
  };

  const sendOtpRequest = async () => {
    const response = null;

    try {
      generateOTPCode(true);

      const response = await axiosInstance.get(
        cacheBuster(APIEndpoints.getOtpGenerateResources() + emailID),
      );

      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        RetryAPI.setResponseReceived(true);
        generateOTPCode(false);
      } else {
        RetryAPI.setResponseReceived(false);
        RetryAPI.setErrorCode(response.status);
        generateOTPCode(false);
        const errorCode = RetryAPI.getErrorCode();
        if (
          HttpErrorHandler.ProcessedException(
            errorCode,
            'We are unable to generate OTP now.',
          )
        ) {
          setServerError(true);
        }
      }
    } catch (error) {
      let errorMessage = '';
      if (error) {
        errorMessage = error.toString();

        RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
      }
      if (error.response) {
        RetryAPI.setErrorCode(error.response.status);
      }

      RetryAPI.setResponseReceived(false);
      generateOTPCode(false);
      const errorCode = RetryAPI.getErrorCode();

      if (
        HttpErrorHandler.ProcessedException(
          errorCode,
          'We are unable to generate OTP now.',
        )
      ) {
        setServerError(true);
      }
      return response;
    }
  };

  const getAdminConfiguration = async () => {
    const response = null;

    try {
      const response = await axiosInstance.get(
        cacheBuster(APIEndpoints.getAdminConfigResources()),
      );

      const getAdminConfigDataResp = await response.data;

      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        OTPexpires(
          getAdminConfigDataResp.Response.InsurerClientSettings.OTPExpiresIn,
        );
        OTPlength(
          getAdminConfigDataResp.Response.InsurerClientSettings.OTPLength,
        );
        OTPattempts(
          getAdminConfigDataResp.Response.InsurerClientSettings
            .InvalidOTPAttempts,
        );
        RetryAPI.setResponseReceived(true);
        setLoadAdminConfig(false);
      } else {
        RetryAPI.setResponseReceived(false);
        RetryAPI.setErrorCode(response.status);
        setLoadAdminConfig(false);
        const errorCode = RetryAPI.getErrorCode();
        if (
          HttpErrorHandler.ProcessedException(
            errorCode,
            'We are unable to get your admin configuration now.',
          )
        ) {
          setServerError(true);
        }
      }
    } catch (error) {
      let errorMessage = '';
      if (error) {
        errorMessage = error.toString();

        RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
      }
      if (error.response) {
        RetryAPI.setErrorCode(error.response.status);
      }

      RetryAPI.setResponseReceived(false);
      const errorCode = RetryAPI.getErrorCode();
      setLoadAdminConfig(false);
      if (
        HttpErrorHandler.ProcessedException(
          errorCode,
          'We are unable to get your admin configuration now.',
        )
      ) {
        setServerError(true);
      }
      return response;
    }
  };

  const LogoutRequest = async () => {
    let response;
    bearerToken = CookiesService.get('loginToken');
    //const LogoutAPI = axios.create({
    //headers: {
    //Authorization: bearerToken,
    //'X-ClientID': HttpHeader.getCNAME(),
    //'Accept': 'application/json',
    //},
    //});

    try {
      const response = await axiosInstance.delete(
        APIEndpoints.getLogoutResource(),
      );

      //response = EncrptedResp;

      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        CookiesService.remove('loginToken');
        CookiesService.clear();
      } else {
        HttpErrorHandler.DisplayServerErrorMessage(response.status, '');
        if (
          HttpErrorHandler.ProcessedException(response.status, 'Logout failed.')
        ) {
          this.setState({ serverError: true });
        }
      }
    } catch (error) {
      HttpErrorHandler.DisplayServerErrorMessage(error.response.status, '');

      if (
        HttpErrorHandler.ProcessedException(
          error.response.status,
          'Logout failed.',
        )
      ) {
        this.setState({ serverError: true });
      }
    }
  };

  const returnToLogin = async () => {
    const logoutRequest = await Promise.all([LogoutRequest()]);
    navigate('/admin');
  };

  useEffect(() => {
    const OTPRequest = async () => {
      const sendOtp = await Promise.all([sendOtpRequest()]);

      if (!serverError) {
        const getAdminConfig = await Promise.all([getAdminConfiguration()]);
      }
    };
    OTPRequest();
  }, []);

  if (lock === true) {
    return <Navigate to="/admin/otperror" push={true}></Navigate>;
  }

  if (serverError)
    return <Navigate to="/admin/server-error" push={true}></Navigate>;

  return (
    <div className="logout-header">
      <Header />
      <Container className="mtop30 activationCode">
        <div className="roller"></div>
        <h1>2-Step Verification</h1>
        {loadAdminConfig && (
          <Card className="coverage_loading">
            <Loader
              className="font-weight-bold loader-color"
              size="large"
              active
            >
              Loading Admin Configuration...
            </Loader>
          </Card>
        )}

        {generateOTP && (
          <Card className="coverage_loading">
            <Loader
              className="font-weight-bold loader-color"
              size="large"
              active
            >
              Generating OTP...
            </Loader>
          </Card>
        )}
        <Row>
          <Col>
            {' '}
            <p>
              To verify your email, we have sent a One time Password (OTP) to{' '}
              {maskEmail(emailID)}
            </p>
          </Col>
        </Row>
        <Row className="h-100">
          <Col md={8} lg={8} sm={8}>
            {!loadAdminConfig && !generateOTP && (
              <Formik
                validationSchema={schema}
                initialValues={{
                  oneTimePassword: oneTimePassword,
                }}
                onSubmit={() => verifyOtp(otp)}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  touched,
                  errors,
                  isValid,
                  handleReset,
                }) => {
                  return (
                    <Form
                      onSubmit={handleSubmit}
                      className="border-right-after"
                    >
                      <Form.Group controlId="formBasicEmail">
                        <Form.Label>
                          Enter One time password
                          <span className="form-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="oneTimePassword"
                          placeholder=""
                          className=""
                          value={values.oneTimePassword}
                          onChange={(e) => {
                            handleChange(e);

                            oneTimePasswordValue = e.currentTarget.value;
                          }}
                          onBlur={(e) => {
                            handleBlur(e);
                            setOTP(e.currentTarget.value);
                            setOTPValid(!!isValid);
                            oneTimePasswordValue = e.currentTarget.value;
                          }}
                          isInvalid={errors.oneTimePassword}
                          autoCorrect="off"
                          spellCheck="off"
                          autoFocus={true}
                          autoComplete="off"
                        />
                        <Form.Control.Feedback type="invalid">
                          <p className="recovery-otp">
                            {errors.oneTimePassword}
                          </p>
                        </Form.Control.Feedback>
                      </Form.Group>
                      <span className="otp-expire">
                        Enter OTP sent to you via email. (It will expire in{' '}
                        {min} minutes)
                      </span>
                      <Row style={{ marginTop: '20%' }}>
                        <Col md={3} lg={3} sm={3}>
                          {' '}
                          <h4>
                            {' '}
                            <a onMouseDown={() => returnToLogin()}>
                              Return to Login
                            </a>
                          </h4>
                        </Col>{' '}
                        <Col md={5} lg={5} sm={5}>
                          <h4>
                            Did not get it?{' '}
                            <a onClick={() => sendOtpRequest()}>Resend code.</a>
                          </h4>
                        </Col>
                        <Col md={4} lg={4} sm={4}>
                          <GenericButton
                            type="submit"
                            tabIndex="0"
                            variant="primary"
                            className="float-right"
                          >
                            Continue
                          </GenericButton>
                        </Col>
                      </Row>
                    </Form>
                  );
                }}
              </Formik>
            )}
          </Col>
        </Row>
      </Container>
      <Container className="logout-footer" fluid>
        <Footer />
      </Container>
    </div>
  );
};

export default LoginOTP;
